import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onClick"];
import PropTypes from 'prop-types';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
export default function RemoveButton(_ref) {
  let {
      disabled,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, rest, {
    disabled: disabled,
    onClick: onClick,
    placement: "right",
    size: "small",
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "delete"
    })
  }));
}
RemoveButton.propTypes = {
  ['data-test-id']: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};